import * as React from 'react';
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  TextInput,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  useTranslate,
  useLocaleState,
  required,
  useEditContext,
} from 'react-admin';

import EmptyList from '../components/misc/EmptyList';
import SourceLanguageBanner from '../components/form/SourceLanguageBanner';
import { useSourceLanguage } from '../hooks/useSourceLanguage';

const entity = 'subcategories';

export const SubCategoryList = (props) => {
  const translate = useTranslate();
  const [locale] = useLocaleState();
  const localeNameKey = locale === 'tr' ? 'name.tr' : 'name.en';

  return (
    <List
      {...props}
      empty={<EmptyList entity={entity} />}
      title={translate('subcategories.title', { _: 'Alt Kategoriler' })}
      exporter={false}
    >
      <Datagrid>
        <TextField
          source={localeNameKey}
          label={translate('subcategories.name', { _: 'Alt Kategori Adı' })}
        />
        <ReferenceField
          source="category"
          reference="categories"
          label={translate('subcategories.category', { _: 'Üst Kategori' })}
        >
          <TextField source={localeNameKey} />
        </ReferenceField>
        <EditButton />
      </Datagrid>
    </List>
  );
};

const SubCategoryFormFields = ({ isEdit = false, record }) => {
  const translate = useTranslate();
  const [locale] = useLocaleState();
  const localeNameKey = locale === 'tr' ? 'name.tr' : 'name.en';
  const { localizedSource } = useSourceLanguage({ isEdit, record });

  return (
    <>
      <SourceLanguageBanner isEdit={isEdit} record={record} />
      <TextInput source="id" label="ID" disabled={isEdit} validate={required()} />
      <ReferenceInput
        source="category"
        reference="categories"
        label={translate('subcategories.category', { _: 'Üst Kategori' })}
      >
        <SelectInput optionText={localeNameKey} fullWidth validate={required()} />
      </ReferenceInput>
      <TextInput
        source={localizedSource('name')}
        label={translate('subcategories.name', { _: 'Alt Kategori Adı' })}
        fullWidth
        validate={required()}
      />
    </>
  );
};

const SubCategoryEditForm = () => {
  const { record } = useEditContext();
  return (
    <SimpleForm redirect={`/${entity}`}>
      <SubCategoryFormFields isEdit record={record} />
    </SimpleForm>
  );
};

export const SubCategoryEdit = (props) => {
  const translate = useTranslate();

  return (
    <Edit
      title={translate('subcategories.edit_subcategory', { _: 'Alt Kategoriyi Düzenle' })}
      {...props}
      transform={(data, { previousData }) => ({
        ...data,
        sourceLang: previousData?.sourceLanguage || 'tr',
      })}
    >
      <SubCategoryEditForm />
    </Edit>
  );
};

export const SubCategoryCreate = (props) => {
  const translate = useTranslate();
  const [locale] = useLocaleState();

  return (
    <Create
      title={translate('subcategories.new_subcategory', { _: 'Yeni Alt Kategori' })}
      {...props}
      transform={(data) => ({
        ...data,
        sourceLang: locale || 'tr',
      })}
    >
      <SimpleForm redirect={`/${entity}`}>
        <SubCategoryFormFields isEdit={false} />
      </SimpleForm>
    </Create>
  );
};
